import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {BehaviorSubject, merge, Subject, throwError} from 'rxjs';
import {catchError, concatMap, map, scan } from 'rxjs/operators';

const API_URL_ASISTENCIA = environment.apiUrl + '/api/Asistencia';

@Injectable()
export class ReporteGeneralService {

  private dateChangeSubject = new BehaviorSubject('');
  dateChangeAction$ = this.dateChangeSubject.asObservable();

  allStudentesData$ = this.dateChangeAction$
    .pipe(
      concatMap(date =>
        this.http.get(`${API_URL_ASISTENCIA}/reporte/global/fecha/${date}`)
          .pipe(
            catchError(err => this.handleError(err))
          )
      )
    );

  reportedStudents$ = this.dateChangeAction$
    .pipe(
      concatMap(date =>
        this.http.get<any[]>(`${API_URL_ASISTENCIA}/reporte/fecha/${date}`)
          .pipe(
            catchError(err => this.handleError(err))
          )
      )
    );

  private studentOperationSubject = new Subject<any>();

  studentOperationAction$ = this.studentOperationSubject.asObservable();

  reportedStudentsOp$ = merge(
    this.reportedStudents$,
    this.studentOperationAction$
  )
    .pipe(
      scan((acc, value) => {
        if (value.op === 'remove') {
          return acc.filter(studentI => studentI.alumno.id !== value.student.alumno.id);
        }
        if (value.op === 'add') {
          return [...acc, value.student];
        }
        if (value.op === 'edit') {
          return [...acc.filter(studentI => studentI.alumno.id !== value.student.alumno.id), value.student];
        }
      })
    );

  warningDates$ = this.http.get<any[]>(`${API_URL_ASISTENCIA}/pendiente`)
    .pipe(
      catchError(this.handleError)
    );

  constructor(private http: HttpClient) {
  }

  getListaAlumnos(fecha = '') {
    const url = fecha === '' ? `${API_URL_ASISTENCIA}/alumnos` : `${API_URL_ASISTENCIA}/alumnos/fecha/${fecha}`;
    return this.http.get(url).pipe(
      map(data => data)
    );
  }

  addStudent(student) {
    this.studentOperationSubject.next({op: 'add', student});
  }

  removeStudent(student) {
    this.studentOperationSubject.next({op: 'remove', student});
  }

  editStudent(student) {
    this.studentOperationSubject.next({op: 'edit', student});
  }

  selectedDateChange(date) {
    this.dateChangeSubject.next(date);
  }

  private handleError(err: any) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage: string;
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Backend returned code ${err.status}(${err.statusText}): ${err.error}`;
    }
    return throwError(errorMessage);
  }
}
